import { uniqueString } from '../utils/string'
import Queue from './queue'

const _pool = uniqueString('TaskPool_pool')
const _queue = uniqueString('TaskPool_queue')
const _maxPoolSize = uniqueString('TaskPool_maxPoolSize')
const _maxQueueSize = uniqueString('TaskPool_maxQueueSize')

export default class TaskPool {
  constructor(config = {}) {
    this[_maxPoolSize] = config.poolSize || 10
    this[_maxQueueSize] = config.queueSize || 1000
    this[_pool] = []
    this[_queue] = new Queue()
  }

  get max() {
    return this[_maxPoolSize]
  }

  get size() {
    return this[_pool].length
  }

  get queueSize() {
    return this[_queue].size
  }

  get empty() {
    return !this.size
  }

  get full() {
    return this.size === this[_maxPoolSize]
  }

  add(...tasks) {
    for (const task of tasks) {
      if (this[_pool].length < this[_maxPoolSize]) {
        this._run(task)
      } else if (this[_queue].size < this[_maxQueueSize]) {
        this[_queue].enqueue(task)
      } else {
        break
      }
    }
  }

  _run(task) {
    const promise = task() || Promise.resolve()
    const done = () => this._complete(promise)

    promise.then(done).catch(done)
    this[_pool].push(promise)
  }

  _complete(promise) {
    const index = this[_pool].indexOf(promise)

    if (index < 0) return

    this[_pool].splice(index, 1)

    if (!this.full && this[_queue.size]) {
      const sizeDiff = this[_maxPoolSize] - this[_queue].size

      for (let i = 0; i < sizeDiff; ++i) {
        this._run(this[_queue].dequeue())
      }
    }
  }
}
